import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Navbar.css';
import { checkAuthToken, logoutUser } from './AuthApi';

const NavbarComponent = () => {
  const [expanded, setExpanded] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Check if user is authorized
  useEffect(() => {
    const validateAuth = async () => {
      const isValid = await checkAuthToken();
      setIsAuthorized(isValid);
    };
    validateAuth();
  }, []);

  // Handle navigation
  const handleNavigation = (path) => {
    navigate(path);
    setExpanded(false); // Close navbar when navigating
  };
  
  // Handle sign out
  const handleSignOut = () => {
    const result = logoutUser();
    if(result.success) {
      setIsAuthorized(false);
      navigate('/');
      setExpanded(false);
    }
  };

  return (
    <Navbar bg="white" expand="lg" expanded={expanded} className="py-2 shadow-sm sticky-top">
      <Container fluid="md">
        {/* Logo and Brand */}
        <Navbar.Brand
          onClick={() => handleNavigation('/')}
          className="d-flex align-items-center"
          style={{ cursor: 'pointer' }}
        >
          <img
            src="logo_noText_blue.svg"
            width="30"
            height="30"
            className="d-inline-block align-top me-2"
            alt="Cogitat logo"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          <div className="d-flex flex-column flex-md-row align-items-md-baseline">
            <span className="brand-name">Cogitat</span>
            <span className="brand-tagline ms-md-2">Optimizing Capital Allocation</span>
          </div>
        </Navbar.Brand>
        
        <Navbar.Toggle 
          aria-controls="main-navbar-nav" 
          onClick={() => setExpanded(expanded ? false : "expanded")}
          className="border-0"
        >
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        
        <Navbar.Collapse id="main-navbar-nav">
          <Nav className="ms-auto nav-underline">            
            {!isAuthorized ? (
              <>
                <Nav.Link 
                  onClick={() => handleNavigation('/clients')}
                  className={location.pathname === '/clients' ? 'active' : ''}
                >
                  Clients
                </Nav.Link>
                <Nav.Link 
                  onClick={() => handleNavigation('/contact-us')}
                  className={location.pathname === '/contact-us' ? 'active' : ''}
                >
                  Contact Us
                </Nav.Link>
              </>
            ) : (
              <>
                <Nav.Link 
                  onClick={() => handleNavigation('/vault')}
                  className={location.pathname === '/vault' ? 'active' : ''}
                >
                  The Vault
                </Nav.Link>
                <Nav.Link 
                  onClick={handleSignOut}
                  className="sign-out-link"
                >
                  Sign Out
                </Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarComponent;